import { createContext, useMemo } from "react";
import { Token_Key } from "../utils/helper";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage(Token_Key, null);
    const navigate = useNavigate();

    const login = async (data) => {
        setUser(data);
        navigate('/admin');
    }

    const logout = () => {
        setUser(null);
        localStorage.removeItem(Token_Key);
        navigate('/login');
    }

    const isAdmin = () => {
        return !user ? user : user.role;
    }

    const value = useMemo(() => ({
        user, login, logout, isAdmin
    }), [user]);

    return <AuthContext.Provider value={value}>
        {children}
    </AuthContext.Provider>


}